<template>
  <RevButtonBase
    :aria-expanded="isOpen"
    :aria-label="i18n(translations.title)"
    class="text-static-default-hi rounded-md flex items-center justify-center gap-8 p-4 hover:text-action-default-hi-hover"
    data-test="country-switch-menu-button"
    @click="
      () => {
        trackButtonClick()
        $emit('click')
      }
    "
  >
    <RevCountryFlag v-if="countryCode" class="rounded-xs" :country-code />
    <template v-if="compact">
      <IconChevronUp v-if="isOpen" />
      <IconChevronDown v-else />
    </template>
    <div v-else class="caption-bold">
      {{ currentLanguageAndCountryCode }}
    </div>
  </RevButtonBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  type CountryCodeValue,
  MarketCountryCode,
} from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCountryFlag } from '@ds/components/CountryFlag'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconChevronUp } from '@ds/icons/IconChevronUp'

import { countryDisplayNameBcp47 } from '../../utils/countryDisplayName'

import translations from './CountrySwitch.translations'

const { countryCode, trackingSpot } = defineProps<{
  compact?: boolean
  countryCode: CountryCodeValue
  isOpen: boolean
  trackingSpot: 'header' | 'nav'
}>()
const i18n = useI18n()

const currentLanguageAndCountryCode = computed(() =>
  countryDisplayNameBcp47(i18n.currentLocale, MarketCountryCode[countryCode]),
)

const { trackCountrySwitchClick } = useTracking()

const trackButtonClick = () => {
  trackCountrySwitchClick({
    name: 'country_switch',
    zone: trackingSpot,
  })
}

defineEmits(['click'])
</script>
